import React, { memo, useCallback } from 'react';
import shortid from 'shortid';
import { SearchState } from '../types/index';

const SuggestionCategoriesResults = ({
  suggestionResults,
  submitSearch,
  searchFromSuggestion,
  clickSuggestedTerm,
}: {
  suggestionResults: SearchState['suggestionResults'] | null;
  submitSearch: (term: string, type: string, url?: string) => void;
  searchFromSuggestion: (term: string, type: string, url: string) => void;
  clickSuggestedTerm: (type: string) => void;
}) => {
  const handleCategoryClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>, category: any): void => {
      e.preventDefault();
      clickSuggestedTerm('category');
      window.location.href = submitSearch(category.name, 'category', category.url);
    },
    [clickSuggestedTerm, submitSearch],
  );
  return (
    <>
      {suggestionResults && suggestionResults.categories
        ? suggestionResults.categories.map((category: any) => {
            return (
              <div
                key={shortid()}
                data-testid="sayt-suggested-categories"
                className="dsg-search-suggestion-result-container">
                <button
                  type="button"
                  className="dsg-search-suggestion-result hmf-text-align-left hmf-subheader-l hmf-subheader-m-m"
                  onMouseEnter={() => searchFromSuggestion(category.id, 'category', category.url)}
                  onFocus={() => searchFromSuggestion(category.id, 'category', category.url)}
                  onClick={(e) => handleCategoryClick(e, category)}>
                  <span>{category.name}</span>
                </button>
              </div>
            );
          })
        : ''}
    </>
  );
};

export default memo(
  SuggestionCategoriesResults,
  (prev, next) => prev.suggestionResults === next.suggestionResults,
);
